export default __webpack_public_path__ + "static/media/background-top-left-illustration.036df929.svg";